import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
  standalone: false,
  selector: 'irembogov-custom-time-picker',
  templateUrl: './custom-time-picker.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomTimePickerComponent extends FieldType<FieldTypeConfig> {}
